/**
 * @desc 待出口信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDckRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/dckTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
